// DialogKyukaShinsei.vue
<template>
<div>
      <template>
        <v-btn
          @click.stop = "open()"
          color=""
          class="mygreen"
          dark
          >

            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:22px;" />
          <span>休暇申請</span></v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">休暇申請</span></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="text-left" cols="3">スタッフ名</v-col>
              <v-col cols="9" >
                  <v-select
                        v-model="staff_selected"
                        :items="arr_staff"
                        item-text="name"
                        item-value="id"
                        menu-props="auto"
                        outlined
                        :disabled="update_mode || !is_admin"
                      placeholder="選択してください"
                  ></v-select>
              </v-col>

              <v-col class="text-left" cols="3">取得希望日</v-col>
              <v-col cols="9" >
                  <v-row>
                      <v-col cols="5.5" >
                        <v-menu
                            v-model="menu_from"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="myfrom_text"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="myfrom"
                                @input="menu_from = false; myfrom_text = myfrom"
                                color="mygreen"
                                :no-title="true"
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                :min="min_date_from"
                                :max="max_date_from"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="1" >～</v-col>
                      <v-col cols="5.5" >
                        <v-menu
                            v-model="menu_to"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="myto_text"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="myto"
                            @input="menu_to = false; myto_text = myto"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                            :min="min_date_to"
                            :max="max_date_to"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                  </v-row>
              </v-col>



              <v-col class="text-left" cols="3">休暇種別</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                <v-select outlined
                    :items="syubetu"
                    v-model="syubetu_selected"
                    label=""></v-select>
              </v-col>


              <v-col class="text-left" cols="3">取得理由</v-col>
              <v-col cols="9" class="pt-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="reason"
                          value=""
                        ></v-textarea>
              </v-col>

              <v-col cols="12" class="pt-0 text-right">有休残日数: {{yuukyuu_zan}}</v-col>

            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn
                v-if="update_mode"
                dark
                color="mygreen"
                @click="update()">更新</v-btn>
          <v-btn dark
                v-else
                :disabled="is_disabled"
                color="mygreen"
                style="cursor: pointer;"
                @click="shinsei()">申請</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
import moment from 'moment';
/* eslint-disable */

moment.locale("ja");

export default {

    props: {
      arr_staff: Array,
    },
    created () {
        console.log('%c created: DialogKyukaShinsei.vue', mycolor.created);
    },


    // datas
    data() {
            return {
                update_mode: false,

                this_month: ''+new Date().getFullYear()-1 + '-'  +(''+(new Date().getMonth()+1)).padStart(2, '0'),
                min_date_from: ''+new Date().getFullYear()-1 + '-'  +(''+(new Date().getMonth()+1)).padStart(2, '0') + '-01',
                min_date_to: ''+new Date().getFullYear()-1 + '-'  +(''+(new Date().getMonth()+1)).padStart(2, '0') + '-01',
                max_date_from: ''+new Date().getFullYear()+2 + '-01-01',
                max_date_to: ''+new Date().getFullYear()+2 + '-01-01',

                before_status: '',
                yuukyuu_zan:'',
                staff_selected: '',
                syubetu_selected: '希望日を選んでください.',
                reason:'',


                dialog: false,
                menu_from: '',
                menu_to: '',

                myfrom_text: '',
                myfrom: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

                myto_text: '',
                myto: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),


                from_set: false,
                to_set: false,
                kyuka_id: 0,
                syubetu: ['希望日を選んでください.']
            }
    },

    watch: {
        myfrom_text(val){
            this.updateSyubetuOptions() // ← this. を忘れずにな！👍
            this.min_date_to = val;
            console.log('watch: myfrom_text 変更、min_date_to 更新');
        },

        myto_text(val){
            this.updateSyubetuOptions() // ← こっちも！ this. だぜ！👍
            this.max_date_from = val;
            console.log('watch: myto_text 変更、max_date_from 更新');
        },

        staff_selected(newVal, oldVal){ // staff_selected が変更されたら…
            console.log(`スタッフ選択が変わった！ ${oldVal} -> ${newVal}`);
            // ★新しく作った有休取得メソッドを呼ぶ！
            this.fetchYukyuZan();
        },
    },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),

        is_disabled(){
            // 有休残り日数
            var flag = true;
            if(this.yuukyuu_zan!=='' && this.yuukyuu_zan>0){
                flag = false;
            }
            return flag;
        },
    },
    methods: {
        fetchYukyuZan() {
            // staff_selected に有効な ID があるかチェック！ (空文字とか null 除外)
            if (this.staff_selected && this.staff_selected !== '') {
                console.log(`よし、有休残日数ゲットするぜ！💪 staff_id: ${this.staff_selected}`);
                axios.get('/get_kyuka_nokori_yuukyuu/' + this.staff_selected)
                  .then((res) => {
                    console.group();
                    console.log('%c /get_kyuka_nokori_yuukyuu', mycolor.api);
                    console.log('取得した有休残日数:', res.data);
                    console.groupEnd();
                    this.yuukyuu_zan = res.data; // 取得した残日数をセット！✨
                  })
                  .catch((e) => {
                    console.error('😭 うわっ！有休残日数の取得に失敗した…', e);
                    this.yuukyuu_zan = ''; // エラーだって分かるように表示
                  });
            } else {
                // スタッフが選択されてない (管理者が新規で開いた時とか)
                console.log('スタッフ未選択だから、有休残日数は 0 にしとくぜ！');
                this.yuukyuu_zan = ''; // 残日数を 0 にリセット (もしくは '-' とかでもOK)
            }
        },


        // フォームの値を初期化する専用のメソッドを作るとスッキリするかも！✨
        resetForm() {
          console.log('フォームをリセットするぜ！🧹');
          this.update_mode = false; // 新規モードに
          this.kyuka_id = 0;        // 休暇IDリセット
          this.staff_selected = ''; // スタッフ選択クリア
          // 日付は今日の日付に戻すのが一般的かな？
          this.myfrom_text = '';
          // this.myfrom = '';
          this.myto_text = '';
          // this.myto = '';
          // ↑ watch が動いて syubetu も適切にリセットされるはず！👍
          this.syubetu_selected = '希望日を選んでください.'; // 休暇種別リセット
          this.syubetu = ['希望日を選んでください.']; // 休暇種別の選択肢も初期化
          this.reason = '';       // 理由クリア
          this.yuukyuu_zan = '';     // 有休残日数リセット (スタッフ選んだら再計算されるはず)
          this.before_status = '';  // 更新前のステータスリセット
        },

        updateSyubetuOptions() { // watch から呼び出す共通メソッドにした場合
            if( !/^\d{4}-\d{2}-\d{2}$/.test(this.myfrom_text) || !/^\d{4}-\d{2}-\d{2}$/.test(this.myto_text) ){
                this.syubetu = ['希望日を選んでください.'];
                // this.syubetu_selected = '希望日を選んでください.'; // ← 勝手に変えない！
                console.log('watch: 日付不正なので種別リストリセット');
                return false;
            }

            let currentSelected = this.syubetu_selected; // 今の値を取っておく

            let diff = new Date(this.myto_text) - new Date(this.myfrom_text);
            if( diff > 0 ){
                this.syubetu =  ['全休'];
                console.log('watch: 複数日なので種別リストは「全休」のみに');
                // もし元々「全休」以外が選ばれてたら、「全休」に強制変更
                if (currentSelected !== '全休') {
                    this.syubetu_selected = '全休';
                    console.log('watch: 複数日になったので、種別を「全休」に強制変更');
                }
            }else{
                this.syubetu =  ['全休', '午前休', '午後休'];
                console.log('watch: 同日なので種別リストは３つ');
                // ユーザーが「午前休」とか選んでるなら、そのまま維持されるはず！
                // もし選択肢にない値 (例: '希望日を選んでください.') だったら空にする？
                // if (!this.syubetu.includes(currentSelected)) {
                //    this.syubetu_selected = ''; // ← これは好みによる
                // }
            }
        },

        shinsei(){
            console.log('shinsei()');
            console.log('staff_selected: ', this.staff_selected);
            console.log('syubetu_selected: ', this.syubetu_selected);
            console.log('reason: ', this.reason);
            console.log('kyuka_id: ', this.kyuka_id);
            console.log('myfrom_text: ', this.myfrom_text);
            console.log('myto_text: ', this.myto_text);


            // バリデーション
            if(this.syubetu_selected==='' || this.syubetu_selected==='希望日を選んでください.'){
                alert('休暇種別を選んでください.');
                return false;
            }


            // 日付のバリデーション
            if( !/^\d{4}-\d{2}-\d{2}$/.test(this.myfrom_text) || !/^\d{4}-\d{2}-\d{2}$/.test(this.myto_text) ){
                alert('日付の指定が正しくありません');
                return false;
            }

            // 日付の前後を確認
            let from = (new Date(this.myfrom_text)).getTime();
            let to = (new Date(this.myto_text)).getTime();
            if(from>to){
                alert('日付の指定が正しくありません');
                return false;
            }


            let staff_name = this.arr_staff.filter( (v) =>{
                return v.id==this.staff_selected;
            })[0]['name'];
            axios.post('/insert_kyuka',  {staff_id: this.staff_selected, staff_name: staff_name,  start: this.myfrom_text, end: this.myto_text, syubetu: this.syubetu_selected, reason: this.reason} )
              .then( (res) => {
                console.log('%c /insert_kyuka', mycolor.api);
                console.log(res);
                this.$emit('getlist');  // 親側で休暇リストの取得し直しを要求


                // メール送信
                if(res.data.status==='OK'){
                    console.log('OK');
                    axios.post('/send_kyuka_mail/1', {staff_id: this.staff_selected, staff_name: staff_name,  start: this.myfrom_text, end: this.myto_text, syubetu: this.syubetu_selected, reason: this.reason})
                    .then( (res) => {
                        console.log('%c /send_kyuka_mail/1', mycolor.api);
                        console.log(res);

                        // 有休日数の減算表示のためスタッフ選択をクリアする
                        this.staff_selected = '';
                        this.yuukyuu_zan = '';
                        this.myfrom_text = '';
                        this.myto_text = '';
                        this.syubetu_selected = '';
                        this.reason = '';

                    })
                    .catch();
                }else{
                  alert(res.data.msg);
                }

                this.dialog = false;

              })
              .catch( e => {
                  if(e.response.status===400){
                      alert('既に重複する申請があります.'+"\n"+e.response.data.detail);
                  }
              });

        },  // shinsei()


        open(item){
            console.group()
            console.log('ダイアログを開く！open()');
            console.log('item (更新データ): ', item);
            console.groupEnd();

            this.resetForm(); // まずリセット🧹

            if( !this.is_admin ){
                this.staff_selected = this.user.id;
            }

            if(item){ // 更新モード！
              console.log('更新モードだ！💪 item の値で上書きするぜ！');
              this.update_mode = true;
              this.kyuka_id = item.id;
              this.staff_selected = item.staff_id;
              this.reason = item.reason;
              this.before_status = item.status;

              // --- 日付と休暇種別の順番が重要！ ---

              // 1. まず日付をセット (watch が動くかもしれないけど一旦OK)
              this.myfrom_text = item.start;
              this.myfrom = item.start;
              this.myto_text = item.end;
              this.myto = item.end;

              // 2. ★日付に基づいて「正しい選択肢リスト」をここで作る！★
              //    watch のロジックと同じ判定を使おう！
              let diff = new Date(item.end) - new Date(item.start);
              if (diff > 0) {
                  this.syubetu = ['全休'];
                  console.log('🗓️ open(): 複数日 => 選択肢は「全休」');
              } else {
                  this.syubetu = ['全休', '午前休', '午後休'];
                  console.log('🗓️ open(): 同日 => 選択肢は「全休」「午前休」「午後休」');
              }

              // 3. ★VueがDOMを更新し、watchが落ち着くのを待ってから値をセット！★
              //    $nextTick を使うのが定石だぜ！😎
              this.$nextTick(() => {
                  // この時点で、syubetu 配列は 2. でセットした正しいリストのはず
                  // item.syubetu がそのリストに含まれているか念のためチェック！
                  if (this.syubetu.includes(item.syubetu)) {
                      this.syubetu_selected = item.syubetu;
                      console.log(`✅ $nextTick: 休暇種別「${item.syubetu}」をセット！`);
                  } else {
                      // 万が一、保存されてた種別が日付と矛盾してたら警告出すとか？🤔
                      console.warn(`⚠️ $nextTick: 休暇種別「${item.syubetu}」は現在の日付 (${this.myfrom_text} ~ ${this.myto_text}) では不正です！空欄にします。`);
                      alert(`注意: 選択されていた休暇種別「${item.syubetu}」は、現在の日付設定では選択できません。種別を選び直してください。`);
                      this.syubetu_selected = ''; // 不正なら空欄にして選び直してもらう
                  }

                  // さらに念のため、セット直後の値を確認
                  this.$nextTick(() => {
                      console.log('実際にセットされた syubetu_selected:', this.syubetu_selected);
                  });
              });

            } else {
              // 新規モードの処理... (省略)
            }

            // --- ★★★ ここで必ず有休残日数を取得！ ★★★ ---
            console.log('ダイアログ表示前に、有休残日数を取得開始！🚀');
            this.fetchYukyuZan(); // プロを呼ぶ！📞

            // --- 最後にダイアログ表示 ---
            this.dialog = true;
            console.log('ダイアログ表示！✨');
        },

        update(){
            console.log('update()');
            console.log('staff_selected: ', this.staff_selected);
            console.log('syubetu_selected: ', this.syubetu_selected);
            console.log('reason: ', this.reason);
            console.log('kyuka_id: ', this.kyuka_id);

            axios.post('/update_kyuka',  {staff_id: this.staff_selected, kyuka_id: this.kyuka_id, start: this.myfrom_text, end: this.myto_text, syubetu: this.syubetu_selected, reason: this.reason, status: '承認待ち', before_status: this.before_status} )
              .then((res) => {
                console.log(`%c /update_kyuka`, mycolor.orange);
                console.log(res);

                // FastAPI 側で {status: 'OK'} が返ってきたら成功と判断！
                if (res.data && res.data.status === 'OK') {
                    console.log('🎉 更新成功！親にリスト更新の合図を送るぜ！');
                    this.$emit('getlist'); // ★★★ これを追加するだけ！★★★
                    this.dialog = false; // 成功したらダイアログ閉じる
                } else {
                    // FastAPI側で {status: 'NG'} やエラーが返ってきた場合
                    console.error('😭 更新失敗… FastAPI側でエラーだってさ…', res.data ? res.data.msg : '詳細不明');
                    // ここでユーザーにエラーメッセージを表示する処理を入れると更に Good！👍
                    alert('休暇申請の更新に失敗しました。\n' + (res.data && res.data.msg ? res.data.msg : 'サーバーエラーが発生しました。'));
                    // 失敗した場合はダイアログ閉じない方がいいかも？🤔
                }
              })
              .catch(() => {
                // 通信自体が失敗した場合 (ネットワークエラーとか)
                console.error('💥 axios 通信エラー！', e);
                alert('休暇申請の更新中に通信エラーが発生しました。');
                // この場合もダイアログは閉じない方がいいな！
              });
        }

    }   // methods
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
/*    height: 70px; */
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}


/deep/ .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg{ 
    background: #607d8b !important;
    color: #fff !important;
    cursor: not-allowed !important;
    pointer-events: unset;
}

</style>
